<script>
    import  { Line }  from 'vue-chartjs';
    export default {
        extends: Line,
        props: [
            'data',
            'chartOptions',
            'options'
        ],
        data(){
            return {
                testData: 0,
                options_default: {
                    legend: {
                        display: false,
                    },
                    tooltips: {
                        bodyFontSize: 16,
                        titleFontSize: 16,
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                fontSize: 12,
                                beginAtZero: true,
                            },
                        }],
                        xAxes: [{
                            ticks: {
                                fontSize: 14,
                                fontStyle: 'bold',
                            },
                        }]
                    }
                }
            };
        },
        mounted () {
            var mergedObject = Object.assign({}, this.options_default, this.options);
            this.renderChart(this.data, mergedObject);
        },
        computed:{
            newLabel() {
                return this.data.labels;
            }
        },
        watch: {
            newLabel() {
                this.$data._chart.update();
            },
            watch: {
                'data': {
                    deep: true,
                    handler(data) {
                        var mergedObject = Object.assign({}, this.localOptions, this.options);
                        this.renderChart(this.data, mergedObject);
                    }
                }
            }
        }
    };
</script>